module.exports = __webpack_public_path__ + "img/b3581fe.jpg";